import React from 'react';

const LeaderContext = React.createContext({
  selectedLeader: null,
  setSelectedLeader: () => {}
});

export default LeaderContext;
